const firebase = require('firebase')

let config = {
    apiKey: "AIzaSyBjk51epbiUTo17VZBW_pE-NI3-JC8IcR8",
    authDomain: "react-password-manager-1f796.firebaseapp.com",
    databaseURL: "https://react-password-manager-1f796.firebaseio.com",
    projectId: "react-password-manager-1f796",
    storageBucket: "react-password-manager-1f796.appspot.com",
    messagingSenderId: "595275120449"
};

const db = firebase.initializeApp(config)

export const google = new firebase.auth.GoogleAuthProvider();
export const facebook = new firebase.auth.FacebookAuthProvider();
export const github = new firebase.auth.GithubAuthProvider();;
export const auth = firebase.auth()
export default db;